import { ICON } from "src/constants/icons";
import { HVIcon } from "@repo/HVComponents";

import * as S from "./Card.styled";

interface CardProps {
  title: string;
  desc: string;
  onSendChat: (msg: string) => void;
}

const Card = ({ title, desc, onSendChat }: CardProps) => {
  return (
    <S.CardWrapper onClick={() => onSendChat(desc)}>
      <S.IconWrapper>
        <HVIcon
          name="chat_support"
          scale="large"
          svgProps={{
            ...ICON.SIZE_24,
            ...ICON.COLOR_STROKE
          }}
        />
      </S.IconWrapper>
      <S.CardText>
        <h3>{title}</h3>
        <p>{desc}</p>
      </S.CardText>
    </S.CardWrapper>
  );
};

export default Card;
